export default {
  realTimeSyncId: "scokHFv70NYYmZRPoMCu",
  keySyncLockId: "keySyncLock",
  DRIVER_LICENSE_URL:
    "https://us-central1-elcheapoapp.cloudfunctions.net/driverLicense",
};
